// extracted by mini-css-extract-plugin
export var pageLayout = "layout-module--page-layout--3fq56";
export var main = "layout-module--main--2-fP-";